export default {
  resource: "admin.adminPlugins.show",
  path: "/plugins",

  map() {
    this.route("community-media-structure", { path: "media-structure" });
  },
};
